
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 9.286L.537 1.822A.857.857 0 011.653.527l.096.083L8 6.861l6.251-6.25a.857.857 0 011.116-.084l.096.083c.305.305.332.78.083 1.116l-.083.096L8 9.286z","fill":"#363636"}})])
          )
        }
      }
    